export function padLeft(text: string | null, count: number, placeholder: string) {
    let out = text == null ? '' : text;
    const filler = placeholder.length === 0 ? ' ' : placeholder
    while (out.length < count) {
        out = filler + out
    }
    return out
}